import { useState } from "react";
import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import DitlCountCardContent from "./DitlCountCardContent";

const DitlCallListCard = ({
  count = null,
  title,
  collapsedTitle = null,
  description = null,
  descriptionVariant = "body-m",
  actions = null,
  onDone = null,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => setOpen((prev) => !prev);

  if (open) {
    return (
      <DitlCountCardContent
        count={count}
        title={title}
        description={description}
        descriptionVariant={descriptionVariant}
        actions={actions}
        onToggle={toggle}
        onDone={onDone}
      />
    );
  }

  return (
    <button
      type="button"
      className="tw-flex tw-items-center tw-w-full tw-min-h-[52px] tw-px-[24px] tw-py-[8px] tw-bg-white tw-rounded-[16px] tw-border-[1px] tw-border-solid tw-border-gray-10 tw-text-left tw-cursor-pointer"
      aria-expanded={false}
      onClick={toggle}
    >
      <Typography variant="body-m" component="span">
        {collapsedTitle || title}
      </Typography>
    </button>
  );
};

DitlCallListCard.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string.isRequired,
  collapsedTitle: PropTypes.string,
  description: PropTypes.string,
  descriptionVariant: PropTypes.oneOf(["body-m", "body-s"]),
  actions: PropTypes.node,
  onDone: PropTypes.func,
  defaultOpen: PropTypes.bool,
};

export default DitlCallListCard;
